<template>
  <div class="footerdev">
    <el-row :gutter="0">
      <el-col :span="8"><div class="grid-content ep-bg-purple" /></el-col>
      <el-col :span="2"
        ><div class="grid-content ep-bg-purple" />
        <el-link :underline="false">关于我们</el-link></el-col
      >
      <el-col :span="2"
        ><div class="grid-content ep-bg-purple" />
        <el-link :underline="false">网站介绍</el-link></el-col
      >
      <el-col :span="2"
        ><div class="grid-content ep-bg-purple" />
        <el-link href="/UpdateLog" :underline="false">更新日志</el-link></el-col
      >
      <el-col :span="2"
        ><div class="grid-content ep-bg-purple" />
        <el-link :underline="false">建议反馈</el-link></el-col
      >
      <el-col :span="8"><div class="grid-content ep-bg-purple" /> </el-col>
    </el-row>
    <el-row :gutter="0">
      <el-col :span="10"><div class="grid-content ep-bg-purple" /></el-col>
      <el-col :span="4">
        <img src="../../assets/svg/planet.svg" class="rotating-image"><br/>
        <el-text>Crafted with by ZG-Blog</el-text>
        <br/>
        <br/>
        <el-text type="info" size="large">运行时间 1 天  访客 100</el-text>
        <br/>
        <el-text  type="info" size="large">&copy; 2024 ZG-Blog  <a href="https://beian.miit.gov.cn/" target="_blank" class="beian">陇ICP备2024015266号-1</a></el-text>
      </el-col>
      <el-col :span="10"><div class="grid-content ep-bg-purple" /> </el-col>
    </el-row>
  </div>
</template>  
    
  <style scoped>

  .beian {
    color: #909399;
    text-decoration: none;
  }
.footerdev {
  text-align: center;
  height: 200px;
  margin: 0;
  background-color: rgba(0, 0, 0, 0.5);
  margin: 0 -20px 0px -20px;
}
.el-row {
  /* margin-bottom: 20px; */
  height: 35%;
}
.el-row:last-child {
  margin-bottom: 0;
}
.el-col {
  border-radius: 4px;
}

.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
:deep(.el-link__inner) {
  font-size: 23px;
  color: #ffffff;
}
/* 定义旋转动画 */  
@keyframes rotate-animation {  
    from {  
      transform: rotate(0deg);  
    }  
    to {  
      transform: rotate(-360deg);  
    }  
  }  
  
  /* 应用动画到图片 */  
  .rotating-image {  
    /* 其他样式，如宽度、高度等 */  
    width: 30px;  
    height: auto;  
    /* 动画属性 */  
    animation: rotate-animation 3s linear infinite; /* 2秒完成旋转，匀速变化，无限循环 */  
  } 
</style>